import React, { useState } from 'react'
import './Navbar.css'

const Navbar = ({ colourScheme, clientName, spouse }) => {
    const [menuOpen, setMenuOpen] = useState(false);

    const navItems = [
        { label: 'Home', id: 'home' },
        { label: 'The Details', id: 'details' },
        { label: 'On The Day', id: 'on-the-day' },
        { label: 'Gallery', id: 'gallery' },
        { label: 'Q&A', id: 'qna' },
        { label: 'Gift List', id: 'gift-list' }
    ]

    // Get initials if both names are present
    const getInitials = () => {
        if (clientName && spouse) {
            const clientInitial = clientName.charAt(0).toUpperCase();
            const spouseInitial = spouse.charAt(0).toUpperCase();
            return `${clientInitial} & ${spouseInitial}`;
        }
        return '';
    }

    const handleNavClick = (e, id) => {
        // Keep anchor semantics but prevent default jump
        if (e && e.preventDefault) e.preventDefault();
        setMenuOpen(false);
        const el = document.getElementById(id);
        if (el) {
            const rect = el.getBoundingClientRect();
            const offset = 50; // pixels above the section start
            const scrollTop = window.pageYOffset + rect.top - offset;
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
        }
    }

    return (
        <nav className={`custom-site-navbar ${colourScheme}-navbar`}>
            <div className="navbar-container">
                {/* Burger menu button - mobile only */}
                <button
                    className={`burger-menu ${menuOpen ? 'open' : ''} ${colourScheme}-burger-menu`}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                {/* Desktop nav items */}
                <div className={`nav-items-wrapper ${menuOpen ? 'mobile-open' : ''}`}>
                    {navItems.map((item) => (
                        <a
                            key={item.id}
                            href={`#${item.id}`}
                            className={`nav-item ${colourScheme}-nav-item`}
                            onClick={(e) => handleNavClick(e, item.id)}
                        >
                            {item.label}
                        </a>
                    ))}
                </div>

                {/* Initials - always visible */}
                {getInitials() && (
                    <span className="navbar-initials">
                        {getInitials()}
                    </span>
                )}
            </div>
        </nav>
    )
}

export default Navbar